import React, { useMemo } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

const COLOR = "hsl(262, 83%, 58%)";

export default function AgencyChart({ races }) {
  const data = useMemo(() => {
    const counts = {};
    races.forEach((r) => {
      const ag = r._ad?.agency;
      if (ag) counts[ag] = (counts[ag] || 0) + 1;
    });
    return Object.entries(counts)
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count);
  }, [races]);

  return (
    <div className="bg-card border border-border rounded-lg p-5 space-y-3">
      <p className="text-sm font-semibold">Races by Agency</p>
      {data.length === 0 ? (
        <p className="text-xs text-muted-foreground py-10 text-center">No data</p>
      ) : (
        <ResponsiveContainer width="100%" height={180}>
          <BarChart data={data} layout="vertical" margin={{ left: 10, right: 20, top: 0, bottom: 0 }}>
            <CartesianGrid horizontal={false} strokeDasharray="3 3" stroke="hsl(220,16%,90%)" />
            <XAxis type="number" tick={{ fontSize: 11 }} tickLine={false} axisLine={false} allowDecimals={false} />
            <YAxis type="category" dataKey="name" tick={{ fontSize: 11 }} tickLine={false} axisLine={false} width={60} />
            <Tooltip
              cursor={{ fill: "hsl(220,16%,96%)" }}
              contentStyle={{ fontSize: 12, border: "1px solid hsl(220,16%,88%)", borderRadius: 6 }}
            />
            <Bar dataKey="count" name="Races" radius={[0, 4, 4, 0]} fill={COLOR} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}